<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!--
	Possibilities for this [ngClass] are:

		left-checkbox-layout-with-icons
		left-checkbox-layout-without-icons
		right-checkbox-layout-with-icons
		right-checkbox-layout-without-icons
		left-checkbox-layout-custom
		right-checkbox-layout-custom
-->
<div [ngClass]="overallLayoutCssClass$ | async">
	<ng-container *ngIf="!content?.templateRef; else customContent">
		<!-- ICON -->
		<mat-icon
			*ngIf="icon$ | async as icon"
			class="checkbox-icon"
			(click)="handleClick()"
			[fontIcon]="icon"
			[ngStyle]="dynamicElementStyle$ | async"
			>{{ icon }}
		</mat-icon>

		<!-- LABEL -->
		<div class="checkbox-label" style="{{ 'font-size: ' + fontSize }}" (click)="handleClick()">
			{{ label$ | async }}
		</div>
	</ng-container>

	<!-- CHECKBOX (without label) -->
	<mat-checkbox [formControl]="checkboxFormControl" class="checkbox-box"> </mat-checkbox>

	<ng-template #customContent>
		<ng-container
			[ngTemplateOutlet]="content?.templateRef"
			[ngTemplateOutletContext]="{ handleClickFn: handleClick.bind(this) }"
		></ng-container>
	</ng-template>
</div>
